import React from 'react';
import NumberFormat from 'react-number-format';

export default function NumberFormatCustom(props) {
  const { inputRef, onChange, prefixSymbol, ...other } = props;
  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      thousandSeparator
      isNumericString
      prefix={prefixSymbol}
    />
  );
}
